module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/is-pure.js
// module id = 112
// module chunks = 0